// Chinese Monument Inscription Mapping
// Includes both Simplified (简体) and Traditional (繁體) characters

// Numbers - Traditional form (used on monuments)
export const chineseNumbers = [
  { simplified: '一', traditional: '壹', pinyin: 'yi', name: 'One', english: '1' },
  { simplified: '二', traditional: '貳', pinyin: 'er', name: 'Two', english: '2' },
  { simplified: '三', traditional: '參', pinyin: 'san', name: 'Three', english: '3' },
  { simplified: '四', traditional: '肆', pinyin: 'si', name: 'Four', english: '4' },
  { simplified: '五', traditional: '伍', pinyin: 'wu', name: 'Five', english: '5' },
  { simplified: '六', traditional: '陸', pinyin: 'liu', name: 'Six', english: '6' },
  { simplified: '七', traditional: '柒', pinyin: 'qi', name: 'Seven', english: '7' },
  { simplified: '八', traditional: '捌', pinyin: 'ba', name: 'Eight', english: '8' },
  { simplified: '九', traditional: '玖', pinyin: 'jiu', name: 'Nine', english: '9' },
  { simplified: '十', traditional: '拾', pinyin: 'shi', name: 'Ten', english: '10' },
  { simplified: '百', traditional: '佰', pinyin: 'bai', name: 'Hundred', english: '100' },
  { simplified: '千', traditional: '仟', pinyin: 'qian', name: 'Thousand', english: '1000' },
  { simplified: '万', traditional: '萬', pinyin: 'wan', name: 'Ten Thousand', english: '10000' },
  { simplified: '零', traditional: '零', pinyin: 'ling', name: 'Zero', english: '0' },
];

// Common Chinese surnames (Top 30)
export const chineseSurnames = [
  { simplified: '李', traditional: '李', pinyin: 'Li', name: 'Li', english: 'Li' },
  { simplified: '王', traditional: '王', pinyin: 'Wang', name: 'Wang', english: 'Wang' },
  { simplified: '张', traditional: '張', pinyin: 'Zhang', name: 'Zhang', english: 'Zhang' },
  { simplified: '刘', traditional: '劉', pinyin: 'Liu', name: 'Liu', english: 'Liu' },
  { simplified: '陈', traditional: '陳', pinyin: 'Chen', name: 'Chen', english: 'Chen' },
  { simplified: '杨', traditional: '楊', pinyin: 'Yang', name: 'Yang', english: 'Yang' },
  { simplified: '黄', traditional: '黃', pinyin: 'Huang', name: 'Huang', english: 'Huang' },
  { simplified: '赵', traditional: '趙', pinyin: 'Zhao', name: 'Zhao', english: 'Zhao' },
  { simplified: '吴', traditional: '吳', pinyin: 'Wu', name: 'Wu', english: 'Wu' },
  { simplified: '周', traditional: '周', pinyin: 'Zhou', name: 'Zhou', english: 'Zhou' },
  { simplified: '徐', traditional: '徐', pinyin: 'Xu', name: 'Xu', english: 'Xu' },
  { simplified: '孙', traditional: '孫', pinyin: 'Sun', name: 'Sun', english: 'Sun' },
  { simplified: '马', traditional: '馬', pinyin: 'Ma', name: 'Ma', english: 'Ma' },
  { simplified: '朱', traditional: '朱', pinyin: 'Zhu', name: 'Zhu', english: 'Zhu' },
  { simplified: '胡', traditional: '胡', pinyin: 'Hu', name: 'Hu', english: 'Hu' },
  { simplified: '郭', traditional: '郭', pinyin: 'Guo', name: 'Guo', english: 'Guo' },
  { simplified: '何', traditional: '何', pinyin: 'He', name: 'He', english: 'He' },
  { simplified: '高', traditional: '高', pinyin: 'Gao', name: 'Gao', english: 'Gao' },
  { simplified: '林', traditional: '林', pinyin: 'Lin', name: 'Lin', english: 'Lin' },
  { simplified: '罗', traditional: '羅', pinyin: 'Luo', name: 'Luo', english: 'Luo' },
  { simplified: '郑', traditional: '鄭', pinyin: 'Zheng', name: 'Zheng', english: 'Zheng' },
  { simplified: '梁', traditional: '梁', pinyin: 'Liang', name: 'Liang', english: 'Liang' },
  { simplified: '谢', traditional: '謝', pinyin: 'Xie', name: 'Xie', english: 'Xie' },
  { simplified: '宋', traditional: '宋', pinyin: 'Song', name: 'Song', english: 'Song' },
  { simplified: '唐', traditional: '唐', pinyin: 'Tang', name: 'Tang', english: 'Tang' },
  { simplified: '许', traditional: '許', pinyin: 'Xu', name: 'Xu', english: 'Xu2' },
  { simplified: '韩', traditional: '韓', pinyin: 'Han', name: 'Han', english: 'Han' },
  { simplified: '冯', traditional: '馮', pinyin: 'Feng', name: 'Feng', english: 'Feng' },
  { simplified: '邓', traditional: '鄧', pinyin: 'Deng', name: 'Deng', english: 'Deng' },
  { simplified: '曹', traditional: '曹', pinyin: 'Cao', name: 'Cao', english: 'Cao' },
];

// Memorial and inscription terms
export const memorialTerms = [
  { simplified: '永垂不朽', traditional: '永垂不朽', pinyin: 'yong chui bu xiu', name: 'Forever Remembered', english: 'forever' },
  { simplified: '安息', traditional: '安息', pinyin: 'an xi', name: 'Rest in Peace', english: 'rip' },
  { simplified: '敬悼', traditional: '敬悼', pinyin: 'jing dao', name: 'In Loving Memory', english: 'memory' },
  { simplified: '纪念', traditional: '紀念', pinyin: 'ji nian', name: 'Commemorate', english: 'commemorate' },
  { simplified: '怀念', traditional: '懷念', pinyin: 'huai nian', name: 'Cherish Memory', english: 'cherish' },
  { simplified: '追思', traditional: '追思', pinyin: 'zhui si', name: 'Remember', english: 'remember' },
  { simplified: '永别', traditional: '永別', pinyin: 'yong bie', name: 'Eternal Farewell', english: 'farewell' },
  { simplified: '安眠', traditional: '安眠', pinyin: 'an mian', name: 'Rest Peacefully', english: 'rest' },
  { simplified: '故', traditional: '故', pinyin: 'gu', name: 'Late/Deceased', english: 'late' },
  { simplified: '显考', traditional: '顯考', pinyin: 'xian kao', name: 'Late Father', english: 'father' },
  { simplified: '显妣', traditional: '顯妣', pinyin: 'xian bi', name: 'Late Mother', english: 'mother' },
  { simplified: '之墓', traditional: '之墓', pinyin: 'zhi mu', name: 'Tomb of', english: 'tomb' },
  { simplified: '墓志铭', traditional: '墓誌銘', pinyin: 'mu zhi ming', name: 'Epitaph', english: 'epitaph' },
];

// Date and time characters
export const dateTimeChars = [
  { simplified: '年', traditional: '年', pinyin: 'nian', name: 'Year', english: 'year' },
  { simplified: '月', traditional: '月', pinyin: 'yue', name: 'Month', english: 'month' },
  { simplified: '日', traditional: '日', pinyin: 'ri', name: 'Day', english: 'day' },
  { simplified: '生于', traditional: '生於', pinyin: 'sheng yu', name: 'Born', english: 'born' },
  { simplified: '卒于', traditional: '卒於', pinyin: 'zu yu', name: 'Died', english: 'died' },
  { simplified: '享年', traditional: '享年', pinyin: 'xiang nian', name: 'Lived', english: 'lived' },
  { simplified: '岁', traditional: '歲', pinyin: 'sui', name: 'Years old', english: 'age' },
  { simplified: '公元', traditional: '公元', pinyin: 'gong yuan', name: 'AD', english: 'ad' },
  { simplified: '农历', traditional: '農曆', pinyin: 'nong li', name: 'Lunar Calendar', english: 'lunar' },
];

// Family relationship terms
export const familyTerms = [
  { simplified: '父', traditional: '父', pinyin: 'fu', name: 'Father', english: 'father' },
  { simplified: '母', traditional: '母', pinyin: 'mu', name: 'Mother', english: 'mother' },
  { simplified: '夫', traditional: '夫', pinyin: 'fu', name: 'Husband', english: 'husband' },
  { simplified: '妻', traditional: '妻', pinyin: 'qi', name: 'Wife', english: 'wife' },
  { simplified: '子', traditional: '子', pinyin: 'zi', name: 'Son', english: 'son' },
  { simplified: '女', traditional: '女', pinyin: 'nv', name: 'Daughter', english: 'daughter' },
  { simplified: '兄', traditional: '兄', pinyin: 'xiong', name: 'Elder Brother', english: 'brother' },
  { simplified: '弟', traditional: '弟', pinyin: 'di', name: 'Younger Brother', english: 'youngbrother' },
  { simplified: '姐', traditional: '姐', pinyin: 'jie', name: 'Elder Sister', english: 'sister' },
  { simplified: '妹', traditional: '妹', pinyin: 'mei', name: 'Younger Sister', english: 'youngsister' },
  { simplified: '祖父', traditional: '祖父', pinyin: 'zu fu', name: 'Grandfather', english: 'grandfather' },
  { simplified: '祖母', traditional: '祖母', pinyin: 'zu mu', name: 'Grandmother', english: 'grandmother' },
  { simplified: '孙', traditional: '孫', pinyin: 'sun', name: 'Grandchild', english: 'grandchild' },
  { simplified: '先生', traditional: '先生', pinyin: 'xian sheng', name: 'Mr.', english: 'mr' },
  { simplified: '女士', traditional: '女士', pinyin: 'nv shi', name: 'Ms.', english: 'ms' },
];

// Common given name characters
export const givenNameChars = [
  { simplified: '明', traditional: '明', pinyin: 'ming', name: 'Bright', english: 'ming' },
  { simplified: '华', traditional: '華', pinyin: 'hua', name: 'Splendid', english: 'hua' },
  { simplified: '伟', traditional: '偉', pinyin: 'wei', name: 'Great', english: 'wei' },
  { simplified: '强', traditional: '強', pinyin: 'qiang', name: 'Strong', english: 'qiang' },
  { simplified: '军', traditional: '軍', pinyin: 'jun', name: 'Army', english: 'jun' },
  { simplified: '平', traditional: '平', pinyin: 'ping', name: 'Peace', english: 'ping' },
  { simplified: '英', traditional: '英', pinyin: 'ying', name: 'Hero', english: 'ying' },
  { simplified: '勇', traditional: '勇', pinyin: 'yong', name: 'Brave', english: 'yong' },
  { simplified: '建', traditional: '建', pinyin: 'jian', name: 'Build', english: 'jian' },
  { simplified: '国', traditional: '國', pinyin: 'guo', name: 'Country', english: 'guo' },
  { simplified: '文', traditional: '文', pinyin: 'wen', name: 'Culture', english: 'wen' },
  { simplified: '志', traditional: '志', pinyin: 'zhi', name: 'Will', english: 'zhi' },
  { simplified: '德', traditional: '德', pinyin: 'de', name: 'Virtue', english: 'de' },
  { simplified: '成', traditional: '成', pinyin: 'cheng', name: 'Success', english: 'cheng' },
  { simplified: '龙', traditional: '龍', pinyin: 'long', name: 'Dragon', english: 'long' },
  { simplified: '凤', traditional: '鳳', pinyin: 'feng', name: 'Phoenix', english: 'feng' },
  { simplified: '春', traditional: '春', pinyin: 'chun', name: 'Spring', english: 'chun' },
  { simplified: '秋', traditional: '秋', pinyin: 'qiu', name: 'Autumn', english: 'qiu' },
  { simplified: '冬', traditional: '冬', pinyin: 'dong', name: 'Winter', english: 'dong' },
  { simplified: '夏', traditional: '夏', pinyin: 'xia', name: 'Summer', english: 'xia' },
  { simplified: '梅', traditional: '梅', pinyin: 'mei', name: 'Plum', english: 'mei' },
  { simplified: '兰', traditional: '蘭', pinyin: 'lan', name: 'Orchid', english: 'lan' },
  { simplified: '竹', traditional: '竹', pinyin: 'zhu', name: 'Bamboo', english: 'zhu' },
  { simplified: '菊', traditional: '菊', pinyin: 'ju', name: 'Chrysanthemum', english: 'ju' },
  { simplified: '云', traditional: '雲', pinyin: 'yun', name: 'Cloud', english: 'yun' },
  { simplified: '山', traditional: '山', pinyin: 'shan', name: 'Mountain', english: 'shan' },
  { simplified: '海', traditional: '海', pinyin: 'hai', name: 'Sea', english: 'hai' },
  { simplified: '天', traditional: '天', pinyin: 'tian', name: 'Sky', english: 'tian' },
];

// Symbols and punctuation
export const chineseSymbols = [
  { simplified: '，', traditional: '，', pinyin: ',', name: 'Comma', english: 'comma' },
  { simplified: '。', traditional: '。', pinyin: '.', name: 'Period', english: 'period' },
  { simplified: '、', traditional: '、', name: 'Enumeration Comma', english: 'enum' },
  { simplified: '：', traditional: '：', name: 'Colon', english: 'colon' },
  { simplified: '；', traditional: '；', name: 'Semicolon', english: 'semicolon' },
  { simplified: '！', traditional: '！', name: 'Exclamation', english: 'exclaim' },
  { simplified: '？', traditional: '？', name: 'Question', english: 'question' },
  { simplified: '「', traditional: '「', name: 'Left Quote', english: 'lquote' },
  { simplified: '」', traditional: '」', name: 'Right Quote', english: 'rquote' },
  { simplified: '『', traditional: '『', name: 'Left Double Quote', english: 'ldquote' },
  { simplified: '』', traditional: '』', name: 'Right Double Quote', english: 'rdquote' },
  { simplified: '（', traditional: '（', name: 'Left Paren', english: 'lparen' },
  { simplified: '）', traditional: '）', name: 'Right Paren', english: 'rparen' },
  { simplified: '—', traditional: '—', name: 'Dash', english: 'dash' },
  { simplified: '…', traditional: '…', name: 'Ellipsis', english: 'ellipsis' },
  { simplified: ' ', traditional: ' ', name: 'Space', english: 'space' },
];

// All characters for keyboard - organized by category
export const chineseLetters = [
  ...chineseNumbers,
  ...chineseSurnames.slice(0, 21), // First 21 surnames for main keyboard
];

// Additional forms (second tab)
export const chineseAdditionalForms = [
  ...givenNameChars,
];

// Common abbreviations/phrases (third tab)
export const chineseAbbreviations = [
  ...memorialTerms,
  ...dateTimeChars,
  ...familyTerms,
];

// Export symbols separately
export { chineseSymbols as symbols };

// Conversion function - for now, just returns the input
// In a full implementation, this could handle pinyin input or character lookup
export const convertToChinese = (text) => {
  return text;
};

// Chart rows for proof sheet (showing common characters)
export const chineseChartRow1 = [
  ...chineseNumbers.slice(0, 10), // Numbers 1-10
  ...chineseSurnames.slice(0, 4), // Top 4 surnames
];

export const chineseChartRow2 = [
  ...chineseSurnames.slice(4, 14), // Next 10 surnames
  ...dateTimeChars.slice(0, 4), // Date characters
];
